import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const cel = { padding: '8px 10px', borderBottom: '1px solid #e5e7eb', textAlign: 'left' };
const veld = { padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 6, background: '#fff', color: '#222' };
const knop = { padding: '8px 14px', border: 'none', borderRadius: 6, background: '#2563eb', color: '#fff', cursor: 'pointer' };

export default function Ordernummers() {
  const [lijst, setLijst] = useState([]);
  const [zoek, setZoek] = useState('');
  const [nummer, setNummer] = useState('');
  const [oms, setOms] = useState('');
  const [toonAfgesloten, setToonAfgesloten] = useState(false);

  const laden = useCallback(() => {
    api.get('/ordernummers?alles=1').then(r => setLijst(r.data.ordernummers || [])).catch(() => setLijst([]));
  }, []);
  useEffect(() => { laden(); }, [laden]);

  const fout = (e) => alert(e?.response?.data?.message || 'Actie mislukt');
  const toevoegen = (e) => {
    e.preventDefault();
    if (!nummer.trim()) return;
    api.post('/ordernummers', { nummer: nummer.trim(), omschrijving: oms.trim() })
      .then(() => { setNummer(''); setOms(''); laden(); }).catch(fout);
  };
  const wijzig = (id, body) => api.put(`/ordernummers/${id}`, body).then(laden).catch(fout);

  const z = zoek.trim().toLowerCase();
  const zichtbaar = lijst.filter(o => (toonAfgesloten || o.actief) && (!z ||
    o.nummer.toLowerCase().includes(z) || (o.omschrijving || '').toLowerCase().includes(z) ||
    (o.laatste_titel || '').toLowerCase().includes(z)));

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 20 }}>
      <div style={{ background: '#fff', color: '#222', borderRadius: 10, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,.1)' }}>
        <h2 style={{ marginTop: 0 }}>Ordernummers</h2>
        <form onSubmit={toevoegen} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
          <input style={{ ...veld, width: 150 }} value={nummer} onChange={e => setNummer(e.target.value)} placeholder="Ordernummer" maxLength={50} />
          <input style={{ ...veld, flex: 1, minWidth: 200 }} value={oms} onChange={e => setOms(e.target.value)} placeholder="Korte omschrijving" maxLength={60} />
          <button type="submit" style={knop}>Toevoegen</button>
        </form>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 8 }}>
          <input style={{ ...veld, flex: 1 }} value={zoek} onChange={e => setZoek(e.target.value)} placeholder="Zoeken op nummer of omschrijving" />
          <label style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
            <input type="checkbox" checked={toonAfgesloten} onChange={e => setToonAfgesloten(e.target.checked)} /> Toon afgesloten
          </label>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr><th style={cel}>Nummer</th><th style={cel}>Omschrijving</th><th style={cel}></th></tr>
          </thead>
          <tbody>
            {zichtbaar.map(o => (
              <tr key={o.id} style={{ opacity: o.actief ? 1 : 0.5 }}>
                <td style={{ ...cel, fontVariantNumeric: 'tabular-nums', fontWeight: 600, whiteSpace: 'nowrap' }}>{o.nummer}</td>
                <td style={cel}>
                  <input key={o.id + ':' + (o.omschrijving || '')} style={{ ...veld, width: '100%', boxSizing: 'border-box' }} maxLength={60}
                    defaultValue={o.omschrijving || ''} placeholder={o.laatste_titel ? 'bv. ' + o.laatste_titel : 'Korte omschrijving'}
                    onBlur={e => { const n = e.target.value.trim(); if (n !== (o.omschrijving || '')) wijzig(o.id, { omschrijving: n }); }}
                    onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); }} />
                </td>
                <td style={{ ...cel, textAlign: 'right' }}>
                  <button type="button" style={{ ...knop, background: o.actief ? '#64748b' : '#16a34a' }}
                    onClick={() => wijzig(o.id, { actief: !o.actief })}>{o.actief ? 'Afsluiten' : 'Heropenen'}</button>
                </td>
              </tr>
            ))}
            {zichtbaar.length === 0 && <tr><td style={cel} colSpan={3}>Geen ordernummers gevonden</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
